const initiateToc = () => {

    const setup = () => {

        // Create ToC link and heading pairs
        const tocItems = [];
        document.querySelectorAll('#toc-list a').forEach(anchor => {
            const targetId = anchor.getAttribute('href').substring(1);
            const targetElement = document.getElementById(targetId);
            if (targetElement) {
                tocItems.push({ tocLink: anchor, heading: targetElement });
            }
        });

        // Create list of top nav items
        const topNavItems = [
            { navLink: document.querySelector('#st-post-nav a[href="#main"]'), heading: document.getElementById('main') },
            { navLink: document.querySelector('#st-post-nav a[href="#related-content"]'), heading: document.getElementById('related-content') },
            { navLink: document.querySelector('#st-post-nav a[href="#post-author"]'), heading: document.getElementById('post-author') }
        ];

        const observerOptions = {
            root: null,
            rootMargin: '0px 0px -80% 0px',
            threshold: [0, 1.0]
        };

        const observerCallback = function(entries) {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const activeId = entry.target.id;

                    // Update TOC items
                    tocItems.forEach(item => {
                        if (item.heading.id === activeId) {
                            item.tocLink.classList.add('active');
                        } else {
                            item.tocLink.classList.remove('active');
                        }
                    });

                    // Update top nav items
                    if (activeId === 'main') {
                        topNavItems.forEach(item => {
                            if (item.heading.id === 'main') {
                                item.navLink.classList.add('md:border-b', 'md:border-brand-600');
                            } else {
                                item.navLink.classList.remove('md:border-b', 'md:border-brand-600');
                            }
                        });
                    } else if (activeId === 'related-content') {
                        topNavItems.forEach(item => {
                            if (item.heading.id === 'related-content') {
                                item.navLink.classList.add('md:border-b', 'md:border-brand-600');
                            } else {
                                item.navLink.classList.remove('md:border-b', 'md:border-brand-600');
                            }
                        });
                    } else if (activeId === 'post-author') {
                        topNavItems.forEach(item => {
                            if (item.heading.id === 'post-author') {
                                item.navLink.classList.add('md:border-b', 'md:border-brand-600');
                            } else {
                                item.navLink.classList.remove('md:border-b', 'md:border-brand-600');
                            }
                        });
                    }
                }
            });
        };

        const observer = new IntersectionObserver(observerCallback, observerOptions);
        tocItems.forEach(item => {
            if (item.heading) observer.observe(item.heading);
        });
        topNavItems.forEach(item => {
            if (item.heading) observer.observe(item.heading);
        });
    };
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', setup);
    } else {
        setup();
    }
};

const init = () => {
	initiateToc();

};

export default {
	init
};